import React, { FunctionComponent } from "react"
import { Flex, Box, Text, Center } from "@chakra-ui/react"
import { EmailIcon } from "@chakra-ui/icons"
import CustomH2 from "./CustomH2"
import styled from "@emotion/styled"
import { LinkedinIcon, TwitterIcon } from "react-share"
import { colors, hoverScaleEffect, switchMobile } from "../../theme/theme"
import { Link } from "gatsby"
import {
  contactEmail,
  linkedInProfile,
  twitterProfile,
} from "../../utils/routes"

const StyledEmailIcon = styled(Center)`
  ${hoverScaleEffect}
`

const StyledTwitterIcon = styled(TwitterIcon)`
  ${hoverScaleEffect}
`

const StyledLinkedInIcon = styled(LinkedinIcon)`
  ${hoverScaleEffect}
`

const StyledBox = styled(Box)`
  margin: 0 0.5rem;
`

const StyledFlex = styled(Flex)`
  width: 100%;
  justify-content: center;
  flex-direction: row;
`

interface IContactSectionProps {
  title?: string
  description?: React.ReactElement
}

export const ContactSection: FunctionComponent<IContactSectionProps> = ({
  title = "Contact",
  description = "Feel free to get in touch with me!",
}) => {
  return (
    <Flex
      width="100%"
      flexDir="column"
      justifyContent="center"
      margin="0 auto"
      id="contact-section"
      paddingBottom="2rem"
    >
      <Box>
        <CustomH2 text={title} />
        <Text textAlign="center" padding="0.5rem 0">
          {description}
        </Text>
      </Box>
      <Box>
        <StyledFlex>
          <StyledBox>
            <a href={"mailto:" + contactEmail} title={contactEmail}>
              <StyledEmailIcon
                bgColor={colors.blue.blue4}
                borderRadius="100%"
                w="50px"
                h="50px"
                color={colors.white}
              >
                <EmailIcon w={6} h={6} />
              </StyledEmailIcon>
            </a>
          </StyledBox>
          <StyledBox>
            <Link to={linkedInProfile} target="_blank">
              <StyledLinkedInIcon size={50} round />
            </Link>
          </StyledBox>
          <StyledBox>
            <Link to={twitterProfile} target="_blank">
              <StyledTwitterIcon size={50} round />
            </Link>
          </StyledBox>
        </StyledFlex>
      </Box>
    </Flex>
  )
}

export default ContactSection
